import { Component, ViewChild } from '@angular/core';
import { Platform, NavController, NavParams, ViewController, Events } from 'ionic-angular';
import { EventCodes } from '../core/codes';
import { UserData } from '../providers/user-data';
import { AppSettings } from '../config/app-settings';
import { FeedData } from '../providers/feed-data';
import { Helpers } from '../providers/helpers';

@Component({
	templateUrl: 'modal-share-submit.html'
})

export class ModalShareSubmit {
	public formData: any;
	public currentUser: any;
	public post: any;
	public loading: any;
	@ViewChild('postContentInput') postInput: any;

	constructor(
		public nav: NavController,
		public platform: Platform,
    	public params: NavParams,
    	public viewCtrl: ViewController,
    	private userData: UserData,
    	private feedData: FeedData,
    	private events: Events,
    	private helpers: Helpers,
    	public settings: AppSettings
    ) {	
    	this.initData();
    }

	ionViewDidEnter() {
		this.postInput.setFocus();		
	}

	public dismiss() {
		this.viewCtrl.dismiss();
	}

	public initData(){
		this.currentUser = this.params.get("user");
		this.post = this.params.get("post");
		this.formData = {
			authorName: this.currentUser? this.currentUser.displayName: "",
			authorPic: this.currentUser? this.currentUser.photoURL: "",
			uid: this.currentUser? this.currentUser.uid : 0,
			text: "",
			likeCount: 0,
			shareCount: 0,
			commentCount: 0,
			sharedPost: this.post
		};
	}
  
  	public submitPost(){
  		var self = this;
  		self.showLoading();
  		if(self.returnCount()>=0){
	      self.feedData.addPost(self.currentUser.uid, self.formData, null).subscribe(newPost =>{
	      	// Update share count
	      	self.post.value.shareCount++;
	      	self.feedData.updatePost(self.post.key, self.post.value).subscribe(updated => {
      			self.hideLoading();
		      	self.loading.onDidDismiss(()=>{
		      		self.events.publish(EventCodes.POST_SUBMITTED, newPost);
		      	});
	      	});
	      });
	    } else {
	    	self.hideLoading();
	      	self.loading.onDidDismiss(()=>{
		    	self.events.publish(EventCodes.POST_SUBMITTED_ERROR);
		    });
	    }
  	}

  	public returnCount() {
	    if(this.formData){
	      return this.settings.feedPostMaxChar - this.formData.text.length;
	    }
  	}

  	public getMaxChar(){
  		return this.settings.feedPostMaxChar;
  	}

  	public showLoading(){
        this.loading = this.helpers.showLoading();
    }

    public hideLoading(){
        this.helpers.hideLoading();
    }
}



// WEBPACK FOOTER //
// ./src/components/modal-share-submit.ts